__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.8.3-328ac2c-15227/_next/";